import React, { useState, useEffect } from "react";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { Clear } from "@mui/icons-material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import _isEmpty from "lodash/isEmpty";
import { domainLevelConfig } from "../../../../../../../../../ui-config";
import { connect } from "react-redux";

const SelectField = (props) => {
  const { field, values = {} } = props;
  const { clearField = false } = field;
  const [isClearable, setClearable] = useState(false);
  const [isEditable, setEditValue] = useState(false);
  let _value = props?.fieldValues[field?.key] || values[field?.key] || field.defaultValue;
  if (!field.multiple) {
    _value = typeof _value === "object" && _value !== null ? _value.id : _value;
  }

  const hostConfig =
    domainLevelConfig[props.host] || domainLevelConfig["default"] || {};

  const clear = () => {
    if(!field.disabled) {
      props.onChange(field, "");
      setClearable(false);
      if (!_isEmpty(values)) {
        setEditValue(true);
      }
    }
  };

  useEffect(() => {
    if (clearField) {
      clear();
    }
  }, [clearField]);

  return (
    <>
      { field?.visible &&
        <FormControl
          variant="outlined"
          fullWidth
          required={field.visible && field.required}
          error={props.fieldErrors[field.key] ? true : false}

        >
          <InputLabel> {field.visible && field.label} </InputLabel>

          <Select
            label={field.label}
            variant="outlined"
            disabled={field.disabled}
            IconComponent={
              field.disabled ? () => {
                return <></>
              } :
                _value && _value?.length > 0 && !field.unclosable
                  ? () => {
                    return (
                      <Clear
                        title="Clear All"
                        style={{
                          cursor: "pointer",
                          fontSize: "25",
                          color: hostConfig.themeColor
                            ? hostConfig.themeColor
                            : "#3580ba",
                          margin: "15px",
                        }}
                        onClick={clear}
                      />
                    );
                  }
                  : () => {
                    return <ArrowDropDownIcon style={{
                      cursor: "pointer",
                      fontSize: "25",
                      color: hostConfig.themeColor
                        ? hostConfig.themeColor
                        : "#3580ba",
                      margin: "10px",
                    }} />;
                  }
            }
            key={field.key}
            onOpen={() => {
              setClearable(!isClearable);
              setEditValue(false);
            }}
            open={isClearable}
            defaultValue={_value}
            error={props.fieldErrors[field.key] ? true : false}
            value={!isEditable ? _value || [] : field.multiple ? [] : ""}
            fullWidth
            onChange={(e) => {
              if (!field.multiple) {
                setClearable(false);
              }
              props.onChange(field, e.target.value);
            }}
            onBlur={props.validate.bind(this, field)}
            className="mb-3"
            hidden={!field.visible}
            onClose={() => setClearable(false)}
            required={field.required}
            multiple={field.multiple}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left"
              },
                            style: {
                maxHeight: 450,
                maxWidth: 500,
              }
            }}
          >
            <MenuItem value="" style={{ display: "none" }} />
            {field.multiple ? <MenuItem value="selectall">All</MenuItem> : null}
            {field.options.map((option, index) => {
              return (
                <MenuItem
                  disabled={option.disabled}
                  key={index}
                  value={option.value}
                  style={{ ...(field.optionStyle || {}), whiteSpace: 'normal' }}
                >
                  {option.label}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      }
      {field.info && (
        <span
          style={{
            fontSize: 10,
            display: "block",
            marginTop: "-10px",
            marginLeft: 5,
            ...(field.infoStyle || {}),
          }}
        >
          {renderInfo(_value, props)}
        </span>
      )}
    </>
  );
};

const renderInfo = (value, props) => {
  const info = props.field.info;
  switch (typeof info) {
    case "function":
      return info(value);
    default:
      return info;
  }
};

const mapStateToProps = (state) => {
  return {
    host: state.userReducer.host,
  };
};

export default connect(mapStateToProps)(SelectField);
